module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_vm._v("\n\n  Akcijas preces ...\n\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-518854c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DiscountedGoodsPage.vue
// module id = 342
// module chunks = 1